import supportedStatus from '~/assets/json/supported-status.json'

export const computePriorityPatientItem = (priorityPatient: any) => {
  const devicesStore: any = useDevicesStore()
  const monitorsStore = useMonitorsStore()
  const organizationsStore = useOrganizationsStore()
  const daysSinceAdmission = priorityPatient?.episodeOfCare?.startedAt
    ? 'J' + calculateDaysBetweenDates(priorityPatient?.episodeOfCare?.startedAt, new Date())
    : ''
  const incidentFormatedDate = priorityPatient?.incident?.createdAt
    ? compareDates(priorityPatient?.incident?.createdAt, new Date())
    : ''

  const alerts = priorityPatient?.alerts?.map((alert: any) => {
    const monitor = monitorsStore.getMonitorById(alert.monitorId)

    return {
      id: alert.id,
      indicator: alert.indicator,
      isMissingData: alert.isMissingData,
      severity: alert.severity.toString(),
      monitorName: monitor?.translations?.[0]?.short_name,
      icon: monitor?.icon,
      focus: monitor?.focus,
    }
  })

  const inverse = !Boolean(
    priorityPatient?.episodeOfCare?.status !== 'planned' && !priorityPatient?.incident?.managerId && alerts.length,
  )
  const organizationName = priorityPatient?.episodeOfCare?.referralOrganizationId
    ? organizationsStore.getOrganizationById(priorityPatient?.episodeOfCare?.referralOrganizationId)?.name
    : ''
  const severity =
    priorityPatient?.episodeOfCare?.status !== 'planned' ? calculateSeverity(alerts, priorityPatient?.incident, inverse) : 0

  function calculateSeverity(alerts: any, incident: any, inverse: boolean): number {
    if (inverse) return incident?.severity || 0
    const alterSeverity =
      alerts && alerts.length > 0 ? Math.max(...alerts.map(({ severity }: { severity: number }) => severity)) : 0
    if (alterSeverity > 0) {
      // If there are alerts, get the highest alert severity
      return alterSeverity
    } else if (incident?.severity) {
      // If there are no alerts but there is an incident, get the incident severity
      return incident.severity
    }

    // Default severity is 0 if neither alerts nor incidents are present
    return 0
  }

  const devices = priorityPatient?.deviceDefinitionIds
    ?.map((deviceDefinitionId: string) => {
      const deviceCMS = devicesStore.getDeviceById(deviceDefinitionId)
      const deviceDefinition = devicesStore.getDeviceDefinitionById(deviceDefinitionId)
      if (deviceDefinition) {
        return { ...deviceDefinition, short_name: deviceCMS?.translations?.[0]?.short_name }
      }
      return deviceDefinition
    })
    .filter((i: Record<string, any> | undefined) => i)
  return {
    id: priorityPatient.patient?.id,
    severity,
    firstName: priorityPatient.patient?.firstName,
    lastName: priorityPatient.patient?.lastName,
    messageCount: (priorityPatient?.encountersInProgress || 0).toString(),
    dateOfBirth: priorityPatient.patient?.birthDate,
    gender: priorityPatient.patient?.gender,
    rpi: priorityPatient.patientInformation?.rpi ? priorityPatient.patientInformation?.rpi?.toString() : '?',
    episodeOfCareId: priorityPatient.episodeOfCare?.id,
    incident: priorityPatient?.incident,
    organizationName,
    inverse: !alerts?.length || !!priorityPatient?.incident?.managerId,
    status: supportedStatus.filter((e: any) => e.id === priorityPatient?.episodeOfCare?.status).pop(),
    alerts: inverse ? [] : alerts,
    careType: priorityPatient.episodeOfCare?.careType,
    incidentFormatedDate,
    daysSinceAdmission,
    devices,
    postalCode: priorityPatient?.livingPlace?.postalCode,
    laterThisMonthTotal: priorityPatient?.laterThisMonthTotal || 0,
    inNextDaysTotal: priorityPatient?.inNextDaysTotal || 0,
    todayOrBeforeTotal: priorityPatient?.todayOrBeforeTotal || 0,
    laterThisMonthForRequester: priorityPatient?.laterThisMonthForRequester || 0,
    inNextDaysForRequester: priorityPatient?.inNextDaysForRequester || 0,
    todayOrBeforeForRequester: priorityPatient?.todayOrBeforeForRequester || 0,
  }
}
